import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "fr_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${API_BASE}/api` });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken() && !err.config?.url?.includes("/auth/login")) {
      setToken(null);
      if (window.location.pathname.startsWith("/admin")) window.location.assign("/admin/login");
    }
    return Promise.reject(err);
  }
);

export const errorMessage = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const mediaUrl = (cover) => (cover?.startsWith("/api/") ? `${API_BASE}${cover}` : cover);
